import { createStripeWalletPaymentAttempt } from './stripeWallet';
import googlePayFactory from '../../payments/core/factories/googlepay';

/**
 * Initiates a Stripe Google Pay payment attempt using a ConfirmationToken created on the client
 * from the Express Checkout Element.
 *
 * Thin wrapper over the shared `createStripeWalletPaymentAttempt` factory bound to Google Pay:
 * `payment_type: google_pay`, the Google Pay core payments factory, and the `stripe` / `google_pay`
 * engine/provider defaults. paymentPollingHandler owns terminal outcomes; only
 * `requires_client_action` (3DS over FPAN) is intercepted and returned.
 *
 * @param {string} purchaseToken - The token associated with the purchase.
 * @param {Object} paymentData - The Stripe Google Pay payment data.
 * @param {string} paymentData.confirmationTokenId - Stripe ConfirmationToken ID from the ECE.
 * @param {Object} [paymentData.walletInfo] - Wallet info from the ECE confirm event (e.g.
 *   payment_method_preview data such as brand/funding).
 * @returns {Function} A thunk action that dispatches actions based on the payment flow.
 */
export const stripeGooglePayPaymentAttempt = createStripeWalletPaymentAttempt({
  paymentType: 'google_pay',
  factory: googlePayFactory,
  defaultProvider: 'google_pay',
});

export default stripeGooglePayPaymentAttempt;
